import useOnValueChange from "../../../hooks/useOnValueChange";
import { InputProps } from "../Calculator";
import NumberInput from "../../BuildingBlocks/NumberInput/NumberInput";

const TITLE = "סכום השקעה ראשוני";
const SUBTITLE = "הסכום הראשוני שיופקד";
const NAME = "principal-amount";

const PrincipalAmount = ({ contextKey }: InputProps) => {
  const onValueChange = useOnValueChange(contextKey);

  return (
    <NumberInput
      title={TITLE}
      placeholder={SUBTITLE}
      name={NAME}
      onlyPositive
      isCurrency={true}
      onChange={(value: number) => onValueChange(value)}
    />
  );
};

export default PrincipalAmount;
